import React, { useEffect } from 'react';
import EmptyHeader from '@/components/EmptyHeader';
import $i18n from '@/i18n';
import waiting from '@/assets/waiting.svg';
import Requests from '@/services/request';
import './index.less';
import { history } from 'ice';
import store from '@/store';

const WaitingPage: React.FC = () => {
  const [userState] = store.useModel('user');

  //获取用户信息
  useEffect(() => {
    Requests.get('/rest/intercnn/space/query', { status: 'ACTIVE', pageSize: 1000 }).then((res) => {
      const newList = res?.list || [];
      if (newList.length || userState?.currentUser?.isDuibaUser) {
        history?.push(`/?spaceId=${newList?.[0]?.spaceId || ''}`);
      }
    });
  }, []);

  return (
    <div className="waiting-container">
      <EmptyHeader />
      <div className="page-content">
        <div className="waiting-logo">
          <img src={waiting} alt="" />
        </div>
        <div className="waiting-msg">
          <div className="waiting-content">
            <h2>{$i18n.get({ id: 'aopf.pages.waiting.h2.waiting', dm: '等待' })}</h2>
            <p className="waiting-title">
              {$i18n.get({ id: 'aopf.pages.waiting.WaitingToBeInvited', dm: '等待被邀请' })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default WaitingPage;
